import { TeamParticipationRole } from 'dy-frontend-http-repository/lib/data/enums';

const teamParticipationRoleInformation: { [role in TeamParticipationRole] } = {
    [TeamParticipationRole.LEAD]: 'Lead',
    [TeamParticipationRole.MANAGER]: 'Manager',
    [TeamParticipationRole.MEMBER]: 'Member',
};

export default teamParticipationRoleInformation;
